import axios from "axios";
import { GET } from "modules/genericAPI/api/actions";

export const GET_WEATHER_REQUEST = "GET_WEATHER_REQUEST";
export const GET_WEATHER_RESPONSE = "GET_WEATHER_RESPONSE";
export const GET_WEATHER_FAIL = "GET_WEATHER_FAIL";

export function getWeather(location, isLoading = true) {
    return (dispatch) => {
        dispatch({
            type: GET_WEATHER_REQUEST,
            isLoading: isLoading,
        });

        return axios 
            .get(`/weather/forecast?location=${location}`)
            .then((response) => {
                dispatch({
                    type: GET_WEATHER_RESPONSE,
                    weatherData: response.data, 
                    isLoading: false,
                    error: null,
                });
                return response.data;
            })
            .catch((error) => {
                dispatch({
                    type: GET_WEATHER_FAIL,
                    isLoading: false,
                    error: error.message || 'Failed to fetch weather data',
                });
                throw error;
            });
    };
}